import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LookupProjectFacade } from '../../facades/lookup-project.facade';

@Component({
  selector: 'app-lookup-project-button',
  template: `
    <div>
      <button
        type="button"
        class="btn btn-light border"
        [disabled]="!partnerID"
        ngClass="{ disabled: !partnerID }"
        style="padding: 5px; border-radius: 4px; margin-left: 4px;"
        (click)="toggleLookup()"
      >
        <span class="k-icon k-i-search"></span>
      </button>
    </div>
  `,
})
export class LookupProjectButtonComponent implements OnInit, OnChanges {
  @Input() partnerID: string;

  constructor(private lookupFacade: LookupProjectFacade) {}

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes.partnerID) {
      this.lookupFacade.lookup({ partnerID: this.partnerID }, true);
    }
  }

  toggleLookup() {
    this.lookupFacade.toggleLookup({ partnerID: this.partnerID });
  }
}
